$.extend(true, BT, {
  initStickyCartProductPage: function() {
    if($('.sc').length > 0) {
      $('.sc').removeClass('hide');
      $(window).on(this.data.scrollEventName, (e, direction) => {
        if(this.data.pageLoaded && this.data.updatingProductOptions == false) {
          if(direction == 'down') {
            var btn = $('.button--single-cart-main');
            var headerHeight = $('.sticky-menu.active').length > 0 ? $('.sticky-menu').height() : 0;
            if($(window).scrollTop() + headerHeight > btn.offset().top) {
              $('.sc').addClass('sc--active');
              if(!$('.sc').hasClass('interaction') && this.data.cacheWindowWidth >= 992) {
                $('.sc').addClass('open');
                $('.sc__inner').show();
              }
            } else {
              $('.sc').removeClass('sc--active');
              if(!$('.sc').hasClass('interaction') && this.data.cacheWindowWidth >= 992) {
                $('.sc').removeClass('open');
                $('.sc__inner').hide();
              }
            }
          } else {
            $('.sc').removeClass('sc--active');
            if(!$('.sc').hasClass('interaction') && this.data.cacheWindowWidth >= 992) {
              $('.sc').removeClass('open');
              $('.sc__inner').hide();
            }
          }
        }
      });

      var scSliding = false, statusClass = 'sc__close--working';
      $('.sc__close').on('click', function(e) {
        e.preventDefault();
        if(scSliding) {
          return;
        }
        if(!$('.sc').hasClass('interaction')) {
          $('.sc').addClass('interaction');
        }
        scSliding = true;
        $('.sc').toggleClass('open');
        $('.sc__inner').toggle('slow', function() {
          $('.sc__close').toggleClass(statusClass);
          scSliding = false;
        });
      });

      // Sync the main quantity input and this one in sticky panel
      $('.qty-box__input--single').on('change', (e) => {
        const input = e.currentTarget;
        $('.qty-box__input--single').each((index, ele) => {
          if(!$(ele).is(input)) {
            $(ele).val($(input).val());
          }
        });
      });

      $('.sc__trigger-js').on('click', (e) => {
        e.preventDefault();
        if(scSliding) {
          return;
        }
        scSliding = true;
        $('.sc').show(300, () => {
          scSliding = false;
          $('.sc').addClass('open').addClass('sc--active');
        });
      });

      const stickyCartBtn = $('.add-cart-btn-trigger'), scOptionsSelector =  '.sc__variant';
      $(document).on('click', '.add-cart-btn-trigger', (e) => {
        e.preventDefault();
        const form = $('#' + stickyCartBtn.attr('form'));
        if($(scOptionsSelector).length > 0 && !$(scOptionsSelector).val()) {
          $('body,html').animate({
            scrollTop: (form.offset().top - 100)
          }, 800);
        } else {
          this.startLoadingBtn(stickyCartBtn);
        }
        form.find('.add-cart-btn').first().trigger('click');
      });

      $(document).on('change', '.variant-id--single', (e) => {
        const variantId = $(e.currentTarget).val();
        $(scOptionsSelector).val(variantId);
        if(variantId) {
          this.updateNewVariant($('.sc'), this.data.productGroup[$(scOptionsSelector).attr('data-handle')][variantId], false);
        } else {
          const stickyPg = $(scOptionsSelector).closest(this.selectors.productGroup.wrap);
          this.updateCartBtn(stickyPg);
          this.updateOriginalPriceHtml(stickyPg);
        }
      });
      $(document).on('change', scOptionsSelector, (e) => {
        if (e.originalEvent !== undefined) {
          const select = $(e.currentTarget);
          const variantId = select.val();
          if(variantId) {
            const variant = this.data.productGroup[select.attr('data-handle')][variantId];
            this.populateOptionSelectByVariant($(select.attr('data-pg')), variant, false);
          } else {
            const singlePg = $(select.attr('data-pg'));
            const stickyPg = select.closest(this.selectors.productGroup.wrap);
            this.resetSelectedVariantRows(singlePg);
            this.updateOriginalPriceHtml(stickyPg);
            this.updateCartBtn(stickyPg);
          }
        }
      });
      $(document).on('ajaxCart.afterCartLoad', (e) => {
        this.endLoadingBtn(stickyCartBtn);
      });
    }
  },
  
  initSizeChart: function() {
    if($('.sizechart-trigger').length > 0) {
      $('.sizechart-trigger').unbind('click');
      $('.sizechart-trigger').on('click', (e) => {
        e.preventDefault();
        if($(e.currentTarget).hasClass('sizechart-trigger--inline')) {
          var sizechartTable = $('.sizechart-table');
          var sizechartTab = sizechartTable.parents('.tab-pane');
          var delay = 0;
          if(!sizechartTab.hasClass('.active')) {
            var tabId = sizechartTab.attr('id');
            $('.nav-tab-item a[href="#' + tabId + '"]').trigger('click');
            delay = 300;
          }
          setTimeout(() => {
            var offset = sizechartTable.offset().top - 80;
            if($('.use-sticky').length > 0) {
              offset -= 60;
            }
            offset = offset + 'px';
            $('body,html').animate({
              scrollTop: offset
            }, 800);
          }, delay);
        } else {
          var modalId = $(e.currentTarget).attr('data-modal-id');
          this.showPopup('#' + modalId);
        }
      });
    }
  }
});
BT.initStickyCartProductPage();
class ProductTemplateSection extends BTSection {
  onInit() {
    const scriptDataTag = this.container.find('.product-single-json');
    if(scriptDataTag.length > 0) {
      const handle = scriptDataTag.attr('data-handle');
      BT.data.productGroup[handle] = $.parseJSON(scriptDataTag.html());
      BT.addProductRecentView(scriptDataTag.attr('data-id'));
      const pg = this.container.find(BT.selectors.productGroup.wrap).first();
      BT.updateStorePickup(pg, BT.data.productGroup[handle][scriptDataTag.attr('data-current-variant-id')]);
      
      if(pg.hasClass('reset-variant-rows')) {
        BT.resetVariantsRow(this.container.find(BT.selectors.productGroup.wrap).first(), BT.data.productGroup[handle], true);  
      }
    }
    BT.data.loadedSnippets.push('preload-product-single-general.css');
    const timeout = BT.data.cacheWindowWidth < 768 ? 2000: 500;
    BT.loadCssJsLib('slider', () => {
      BT.initProductThumbsSlider(this.container);
      BT.initProductMainSliderAndZoom(this.container, 1300, 1000);
    });
    
    BT.initDealCountdown(this.container);
    
    setTimeout(() => {
      BT.initSizeChart();
      BT.runProgressBar(this.container.find('.progress-bar'));

      if($('.pg__review-stars--trigger').length > 0) {
        $('.pg__review-stars--trigger').unbind('click');
        $('.pg__review-stars--trigger').on('click',function(e) {
          e.preventDefault();
          var reviewForm = $('.pg__review-form');
          var offsetObj = reviewForm;
          var delay = 0;
          var tabPane = reviewForm.parents('.tab-pane');
          if(tabPane.length > 0) {
            var tabId = tabPane.attr('id');
            if(BT.data.cacheWindowWidth < 991) {
              offsetObj = $('.tab-accordion__trigger[href="#' + tabId + '"]');
            } else {
              offsetObj = $('.nav-tab-item a[href="#' + tabId + '"]');  
            }
            
            if(!tabPane.hasClass('.active')) {
              offsetObj.trigger('click');
            }
            delay = 300;
          } else if (reviewForm.parents('.expand-content').length > 0) {
            var expand_trigger = reviewForm.parents('.expand-content').first().siblings('.expand-trigger').first();
            if(!expand_trigger.hasClass('open')) {
              expand_trigger.trigger('click');
            }
          }

          if(!BT.isInViewport(offsetObj, window)) {
            var offset = offsetObj.offset().top - 100;
            if($('.use-sticky').length > 0) {
              offset -= 60;
            }
            $('html, body').animate({
              scrollTop: offset
            }, 400);
          }
        });
      }

      BT.init3dModel(this.container, this.sectionId);
    }, timeout);

  }


  onLoad(evt) {
    BT.runReLoadReview(this.container, true);
    BT.rteWrap(this.container.find('.rte'));
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $(evt.target).find('.product-single,.sc').removeAttr('data-history');
  }
  onBlockSelect(evt) {
    var tabNav = $(evt.target);
    if(!tabNav.hasClass('open')) {
      tabNav.trigger('click');
    }
    if(!BT.isInViewport(tabNav, evt.currentTarget.defaultView)) {
      var offset = tabNav.offset().top - 100;
      $('html, body').animate({
        scrollTop: offset
      }, 400);
    }
  }
  onUnload() {
    theme.ProductModel.removeSectionModels(this.sectionId);
  }
}
theme.sections.constructors['product'] = ProductTemplateSection;